"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguage = exports.language_list = void 0;
const utils_storage_1 = require("@unboared/utils.storage");
const i18n_js_1 = __importDefault(require("i18n-js"));
const prefered_language_1 = require("./prefered_language");
exports.language_list = ['en', 'fr'];
const initLang = () => {
    let preferedLang = prefered_language_1.PREFERED_LANGUAGE;
    preferedLang = (exports.language_list.includes(preferedLang) ? preferedLang : 'en');
    return preferedLang;
};
exports.useLanguage = (0, utils_storage_1.createPersistStorage)('_lang', (set, get) => ({
    language: initLang(),
    setLanguage: (newLang) => {
        if (exports.language_list.includes(newLang)) {
            i18n_js_1.default.locale = newLang;
            set({ language: newLang });
        }
        else {
            console.log(`[WARNING] ${newLang} is not a language name `);
        }
    },
    toggleLanguage: () => {
        let newLang = (get().language == "en") ? 'fr' : 'en';
        i18n_js_1.default.locale = newLang;
        set({ language: newLang });
    }
}));
//# sourceMappingURL=language.js.map